import QuestionMultipleChoice from "./QuestionMultipleChoice";

export default QuestionMultipleChoice;
